import CardComponent from '../components/CardComponent/CardComponent';
import React, { useContext } from 'react';
import Content from '../components/Layout/Content';
import BannerSlider from '../components/HomeBanner/BannerSlider';
import FindCare from '../components/HomeBanner/FindCare';
import { Grid, Typography } from '@mui/material';
import ApplicationContext from '../context/applicationContext';
import { IconContainer } from '../components/IconContainer/IconContainer';
import { getServiceItems } from '../shared/helper';
import { ServiceContainer } from '../components/ServiceContainer/ServiceContainer';
import {
  FIXED_CARE_SERVICES,
  FIXED_DASHBOARD_SERVICES,
  FIXED_FINANCIAL_SERVICES,
  FIXED_LEGAL_SERVICES,
  FIXED_MEDICAL_SERVICES,
} from '../shared/constants';
import { DASHBOARD } from '../shared/Strings';

const SERVICE_ARRAY = [
  FIXED_MEDICAL_SERVICES,
  FIXED_FINANCIAL_SERVICES,
  FIXED_CARE_SERVICES,
  FIXED_LEGAL_SERVICES,
];

function Dashboard() {
  const appConfig = useContext(ApplicationContext);

  return (
    <Content>
      {appConfig && appConfig.banner && (
        <Grid
          container
          spacing={3}
          direction="column"
          justifyContent="flex-start">
          <Grid item>
            <BannerSlider
              content={appConfig?.banner?.content}
              primaryColor={appConfig?.banner?.primaryColor}
              secondaryColor={appConfig?.banner?.secondaryColor}
            />
          </Grid>
          <Grid item>
            <Typography variant="title">{DASHBOARD.NOTIFICATION_TEXT}</Typography>
            <Grid container spacing={3} sx={{ justifyContent: 'left', marginTop: 1 }}>
              {getServiceItems(
                appConfig.menuItems,
                FIXED_DASHBOARD_SERVICES
              ).map(item => (
                <Grid item key={item.category}>
                  <IconContainer
                    route={item.route}
                    imgUrl={item.icon}
                    caption={item.category}
                    origin={'dashboard'}
                    demoUI={true}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item sx={{ mt: 2 }}>
            <FindCare />
          </Grid>
          <Grid item>
            <CardComponent />
          </Grid>

          <Grid item sx={{ display: { xs: 'none', sm: 'block' }, mt: 2 }}>
            <Typography variant="title">{DASHBOARD.TITLE_TEXT}</Typography>
            <Grid container spacing={2} sx={{ justifyContent: 'left', mt: 1 }}>
              {SERVICE_ARRAY.map((serviceGroup, index) => (
                <Grid item key={index}>
                  <ServiceContainer
                    title={serviceGroup.title}
                    items={getServiceItems(
                      appConfig.menuItems,
                      serviceGroup.services
                    )}
                    viewAllButton={
                      serviceGroup.title === 'Medical' ? true : false
                    }
                    viewAllRoute={
                      serviceGroup.title === 'Medical' ? '/medical' : null
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      )}
    </Content>
  );
}

export default Dashboard;
